/* ===========================================================================
   ROVE NEXT - ADD ONS in the buy box, as SEPARATE CART LINES.
   Rewritten 26 August 2026 (third pass).

   TWO SHAPES OF ADD-ON, ONE ENGINE

   1. SIZE MATCHED (Ophelia). One row per add-on product. The variant is
      chosen from the size already selected for the bed, so nobody picks
      Queen or King twice.

        bed      Ophelia Form Bed / King / Pearl        NT32KNS-005
        + line   Ophelia Form Under-Bed Drawers / King  NT32CSK-001
        + line   Alba Mattress / King                   NT29K-001

   2. SWATCHED (Sphere Pillow on Diane and Reya). ONE checkbox, with the
      colourways as swatches underneath it.

      The first version of this listed one checkbox per colourway - six rows
      reading "Sphere Pillow - Moonstone", "Sphere Pillow - Black" and so on.
      Sharon, 26 Aug: "I kinda don't like the layout where it's a bunch of
      checkbox... couldn't you just have one that says add on sphere pillow
      as a checkbox, and then above or below that we have the colour
      swatches." She is right - six checkboxes for one product reads like six
      products, and it buried the sofa's own swatch row directly above it.

      So: tick ONE box, and the swatches appear. Tapping a swatch selects it;
      tapping more than one selects more than one, because the requirement
      that produced the six rows still stands - the shopper must be able to
      take multiple pillows AND multiple colours. Each chosen colour gets its
      own quantity stepper, so two Dune and one Pearl is one tick, two taps
      and a stepper.

      Ticking the box preselects whichever colour matches the sofa, so the
      common case is a single click. Nothing is forced - a contrasting
      pillow is a perfectly reasonable thing to want.

      MINUS AT ONE REMOVES THE COLOUR. Sharon, 26 Aug: "when I try to remove
      one by putting the minus one, it doesn't work unless I check off the
      circle." The stepper used to clamp at a floor of 1, so the only way
      back out was to find the swatch again. Pressing minus on the last one
      now deselects that colour outright, and dropping the last colour
      unticks the whole add-on.

   NO BACKSLASHES IN THIS FILE, DELIBERATELY. It is written to the theme
   through a GraphQL block string, which passes backslashes through verbatim
   rather than unescaping them. A regex literal here arrived with doubled
   backslashes on 26 Aug and threw "Invalid regular expression flags", which
   killed the whole add-on block. String methods are used instead.

   WHY IT HOOKS cart:update
   sections/rn-buybox.liquid builds its own payload, hardcoded to a single
   item, and dispatches cart:update with source rn-buybox on success. That is
   the only clean seam for extra lines without editing the 129KB section.
   Every ticked add-on goes in ONE follow-up request, so the cart drawer opens
   once with everything already in it.

   TO ADD ANOTHER ADD-ON: add an entry to MAP. Nothing else changes.
   =========================================================================== */
(function () {
  var MAP = {
    'ophelia-form-bed': {
      heading: 'Bundle and save',
      items: [
        { handle: 'ophelia-form-under-bed-drawers',
          label: 'Storage Drawers',
          note: 'Two wheeled, quiet-close drawers that slide under the bed.',
          /* Sharon, 28 Aug, supplied transparent PNGs: "use that instead in the
             add on box because it's on a transparent background ... I would
             suggest using a close-up shot, so it's really only showing the
             drawer." Both supplied files are the WHOLE bed, so this is a crop
             of the drawer taken from the wider render, kept on its alpha.
             Same treatment as the sphere cut-outs: a filename under FILE_BASE,
             sized by width only, never centre-cropped. */
          /* Sharon, 28 Aug, on the first crop: "you need to zoom out because
             it's too cut off, we can't see the entire drawer." Widened from a
             760x520 window of the render to 1100x860, so the whole unit is in
             frame with a little context, not a tight detail of the interior. */
          photo: 'RN_Ophelia_Storage_Drawer_Wide.png' },
        { handle: 'alba-mattress',
          label: 'Alba Mattress',
          /* Sharon, 15 Oct: "just remove that entirely" -- was "Completes the
             bed in one delivery, in the size you chose." Blank, not deleted:
             makeRow() does `note || ''`, and note also backstops the size-dims
             line below for any size with no entry in `dims` -- Ophelia is
             Queen/King only, both covered, so that fallback can never fire for
             this item, but the field stays in shape rather than removed. */
          note: '',
          /* Sharon, 28 Aug: "if they select queen and they hover over the alba
             mattress, then you show the queen dimensions. if they did king,
             then you show the king size."

             Keyed by the SIZE OPTION VALUE, because that is what currentSize()
             reads off the bed's own picker — so the card can never show Queen
             dimensions to someone buying a King. A size with no entry here
             falls back to the row's note rather than printing a wrong figure. */
          dims: { 'Queen': '60 × 80 × 12 in', 'King': '76 × 80 × 12 in' },
          desc: 'A Tencel top over cool gel memory foam and a pocket spring '
              + 'core, with a foam-encased perimeter for edge support. '
              + 'OEKO-TEX® certified, soft feel, in Bone.',
          /* The automatic Shopify discount "Alba Mattress 50% with an Ophelia
             bed" covers this row. The drawers above it are NOT covered and
             carry no flag, which is the whole reason the flag is per row and
             not on the heading. */
          bundled: true }
      ]
    },
    'diane-form-sleeper-sofa': {
      heading: 'Bundle and save',
      items: [
        { handle: 'sphere-pillow',
          label: 'Sphere Pillow',
          /* 13 Oct 2026, Sharon: "just remove the 12 by 12 by 12 inches ...
             we'll leave the View details, at least that would take it down a
             little bit more" -- on every PDP, not only Reya, which is why both
             copies of this row are blanked and not only the Reya one. The
             measurement is still on the Sphere Pillow's own page, which is
             where View details goes. Ophelia's two rows KEEP their notes:
             those are sentences explaining an unfamiliar product, not a
             measurement. */
          note: '',
          /* Sharon, 28 Aug: "no one knows what the sphere pillow is" - the
             hover card showed a name and a measurement and nothing else.
             This is the row's own description, shown ONLY in the enlarged
             card, where there is room for it. The row itself stays a name,
             a measurement and a link. */
          desc: 'A rounded accent pillow in the same performance upholstery. '
              + '100% vegan bio-cotton fill, removable cover. Water repellent, '
              + 'OEKO-TEX® certified, tested to 100,000 double rubs.',
          link: '/products/sphere-pillow',
          linkLabel: 'View details',
          swatched: true,
          bundled: true }
      ]
    },
    'reya-form': {
      heading: 'Bundle and save',
      items: [
        /* NO REYA MODULES IN THIS PANEL.

           Sharon, 8 September: *"I don't think we need to have the add-ons on the
           Reya PDP, because they're already buying a 2-piece or 4-piece. The Reya
           pieces add-on should be on the Add-Ons page and have its own
           independent PDP."*

           Someone on this page is CHOOSING a sofa, not extending one. The corner
           is for an owner who already has a Reya at home, and that person arrives
           through the Add-Ons page, not through the configurator. Offering it
           here asked a buyer to think about their second purchase before they had
           made their first.

           The corners now live as two products of their own — Reya Left Corner
           and Reya Right Corner — each with its own PDP built on the same
           rn-buybox template as the Sphere Pillow and the Under-Bed Drawers.

           The colour-matched row shape built for them on 8 Sep is KEPT in this
           file (variantForModule, and the colourMatched branch in sync). It costs
           nothing while unused, and the moment any product wants one row per
           module matched to the sofa's colourway, it is already here and already
           tested. */
        { handle: 'sphere-pillow',
          label: 'Sphere Pillow',
          /* 13 Oct 2026, Sharon: "just remove the 12 by 12 by 12 inches ...
             we'll leave the View details, at least that would take it down a
             little bit more" -- on every PDP, not only Reya, which is why both
             copies of this row are blanked and not only the Reya one. The
             measurement is still on the Sphere Pillow's own page, which is
             where View details goes. Ophelia's two rows KEEP their notes:
             those are sentences explaining an unfamiliar product, not a
             measurement. */
          note: '',
          desc: 'A rounded accent pillow in the same performance upholstery. '
              + '100% vegan bio-cotton fill, removable cover. Water repellent, '
              + 'OEKO-TEX® certified, tested to 100,000 double rubs.',
          link: '/products/sphere-pillow',
          linkLabel: 'View details',
          swatched: true,
          bundled: true }
      ]
    }
  };

  var segs = location.pathname.split('/');
  var pidx = segs.indexOf('products');
  var handle = pidx >= 0 && segs[pidx + 1] ? segs[pidx + 1].split('?')[0].split('#')[0] : '';
  var cfg = MAP[handle];
  if (!cfg) return;
  var bb = document.querySelector('[id^="rn-bb-"]');
  if (!bb) return;

  /* The storage axis is gone from Ophelia, so nothing may hold the bed off
     its own match. Cleared in case an older render set it. */
  if (bb.hasAttribute('data-rn-force-variant')) bb.removeAttribute('data-rn-force-variant');

  /* Retire the two controls this group replaces on Ophelia. */
  var storageRow = bb.querySelectorAll('.bb-cfg .bb-cfgrow')[1];
  if (storageRow && storageRow.querySelector('[data-cfg-axis="chaise"]')) {
    storageRow.parentNode.removeChild(storageRow);
  }
  var albaOpts = bb.querySelector('.bb-opts[data-group="alba"]');
  if (albaOpts) {
    var albaSect = albaOpts.closest('.bb-sect');
    if (albaSect) albaSect.parentNode.removeChild(albaSect);
  }

  var TICK = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">'
           + '<path d="M2.6 8.4l3.5 3.5 7.3-7.8" fill="none" stroke="currentColor"'
           + ' stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* Styling lives here rather than in a stylesheet so the whole add-on
     mechanism stays in one reviewable file. The 30px left inset lines the
     revealed controls up with the row's text, clear of the checkbox. */
  if (!document.getElementById('rn-ao-qty-style')) {
    var st = document.createElement('style');
    st.id = 'rn-ao-qty-style';
    st.textContent =
      '[id^="rn-bb-"] .rn-ao-grp .rn-ao-sw{display:none;flex-wrap:wrap;gap:8px;margin:10px 0 0;padding-left:30px}'
    + '[id^="rn-bb-"] .rn-ao-grp.on .rn-ao-sw{display:flex}'
    + '[id^="rn-bb-"] .rn-ao-sw button{appearance:none;padding:0;width:34px;height:34px;flex:0 0 auto;'
    + 'border-radius:50%;overflow:hidden;border:1px solid var(--rn-line);background:#eeeae3;cursor:pointer}'
    + '[id^="rn-bb-"] .rn-ao-sw button img{width:100%;height:100%;object-fit:cover;display:block}'
    + '[id^="rn-bb-"] .rn-ao-sw button.on{border-color:var(--rn-ink);'
    + 'box-shadow:0 0 0 2px #fff inset,0 0 0 2px var(--rn-ink)}'
    + '[id^="rn-bb-"] .rn-ao-sw button:focus-visible{outline:2px solid var(--rn-ink);outline-offset:2px}'
    + '[id^="rn-bb-"] .rn-ao-grp .rn-ao-hint{display:none;margin:9px 0 0;padding-left:30px;font-size:10.5px;'
    + 'font-weight:600;letter-spacing:.08em;text-transform:uppercase;color:var(--rn-ink45)}'
    + '[id^="rn-bb-"] .rn-ao-grp.on .rn-ao-hint:not(:empty){display:block}'
    + '[id^="rn-bb-"] .rn-ao-grp .rn-ao-picks{display:none;margin:6px 0 0;padding-left:30px}'
    + '[id^="rn-bb-"] .rn-ao-grp.on .rn-ao-picks{display:block}'
    + '[id^="rn-bb-"] .rn-ao-pick{display:flex;align-items:center;gap:8px;padding:5px 0;'
    + 'font-size:12.5px;line-height:1.3;color:var(--rn-ink)}'
    + '[id^="rn-bb-"] .rn-ao-pick .nm{font-weight:600}'
    + '[id^="rn-bb-"] .rn-ao-pick .qty{display:flex;align-items:center;gap:2px;margin-left:auto;flex:0 0 auto}'
    + '[id^="rn-bb-"] .rn-ao-pick .qty button{appearance:none;width:22px;height:22px;padding:0;line-height:1;'
    + 'border:1px solid var(--rn-line);background:#fff;border-radius:3px;cursor:pointer;'
    + 'font-family:inherit;font-size:13px;color:var(--rn-ink);display:grid;place-items:center}'
    + '[id^="rn-bb-"] .rn-ao-pick .qty button:hover{border-color:var(--rn-ink45)}'
    + '[id^="rn-bb-"] .rn-ao-pick .qty output{min-width:16px;text-align:center;font-size:12px;font-weight:600}'
    /* Sharon, 28 Aug: "no one knows what the sphere pillow is". A 46px
       product shot and a link to its page, with the written description
       replaced by the measurement. .th:empty collapses, so a row whose
       product has no photo looks exactly as it did before. */
    /* Sharon, 28 Aug: the photo sits on the RIGHT of the row and fills the
       box. order:9 moves it past the text without touching the DOM, and
       the negative margins cancel the row's own padding so the image
       runs edge to edge, top to bottom. The row gets overflow:hidden so
       the card's rounded corner clips it. align-self:stretch means the
       height follows the row rather than being guessed. */
    /* The photo is a transparent cut-out on a white card, so it needs no
       background and no dividing rule - it just sits in the box. contain,
       not cover, because a cut-out must never be cropped. NO overflow:hidden
       on the row: the hover card has to be able to escape it. */
    + '[id^="rn-bb-"] .rn-ao{position:relative}'
    + '[id^="rn-bb-"] .rn-ao .th{order:9;flex:0 0 auto;width:104px;align-self:stretch;'
    + 'margin:-11px -8px -11px 0;background:transparent;border:0;position:relative}'
    + '[id^="rn-bb-"] .rn-ao .th img{width:100%;height:100%;object-fit:contain;display:block;'
    + 'transition:transform .22s ease}'
    + '@media(max-width:600px){[id^="rn-bb-"] .rn-ao .th{width:88px;margin:-9px -6px -9px 0}}'
    /* HOVER TO ENLARGE, the same idea as the fabric swatch popover. Pointer
       devices only: :hover on a touchscreen sticks after a tap, which would
       leave the card open with no way to dismiss it. */
    /* Base state is display:none so a touch device never renders the card in
       flow - without this it lays out inline and stretches the row. */
    + '[id^="rn-bb-"] .rn-ao-zoom{display:none}'
    + '@media(hover:hover) and (pointer:fine){'
    + '[id^="rn-bb-"] .rn-ao .th:hover img{transform:scale(1.12)}'
    /* 272px, not 250: the description below the measurement needs a line
       long enough to stop reading as a column of fragments. The image gives
       up 20px of height to pay for it, so the card sits in much the same
       envelope as before. */
    + '[id^="rn-bb-"] .rn-ao-zoom{display:block;position:absolute;right:0;bottom:calc(100% + 10px);z-index:40;'
    + 'width:272px;padding:16px;background:#fff;border:1px solid var(--rn-line);border-radius:10px;'
    + 'box-shadow:0 10px 30px rgba(26,23,18,.16);opacity:0;visibility:hidden;transform:translateY(6px);'
    + 'transition:opacity .18s ease,transform .18s ease,visibility .18s;pointer-events:none}'
    + '[id^="rn-bb-"] .rn-ao .th:hover ~ .rn-ao-zoom,'
    + '[id^="rn-bb-"] .rn-ao-zoom:hover{opacity:1;visibility:visible;transform:translateY(0)}'
    + '[id^="rn-bb-"] .rn-ao-zoom img{width:100%;height:150px;object-fit:contain;display:block}'
    + '[id^="rn-bb-"] .rn-ao-zoom b{display:block;margin-top:10px;font-size:14px;color:var(--rn-ink)}'
    + '[id^="rn-bb-"] .rn-ao-zoom .dm{display:block;margin-top:3px;font-size:12.5px;color:var(--rn-ink70)}'
    /* The rule separates the measurement from the prose so the two do not
       read as one run-on paragraph. Collapses entirely when a row carries
       no desc, which is every add-on except the pillow. */
    + '[id^="rn-bb-"] .rn-ao-zoom .ds{display:block;margin-top:10px;padding-top:10px;'
    + 'border-top:1px solid var(--rn-line);font-size:12px;line-height:1.5;color:var(--rn-ink70)}'
    + '[id^="rn-bb-"] .rn-ao-zoom .ds:empty{display:none}'
    + '}'
    + '[id^="rn-bb-"] .rn-ao .th:empty{display:none}'
    + '[id^="rn-bb-"] .rn-ao .tx .lk{display:inline-block;margin-top:3px;font-size:12px;'
    + 'color:var(--rn-ink70);text-decoration:underline;text-underline-offset:2px}'
    + '[id^="rn-bb-"] .rn-ao .tx .lk:hover{color:var(--rn-ink)}'
    + '[id^="rn-bb-"] .rn-ao .pr .wasp{margin-left:6px;text-decoration:line-through;'
    + 'opacity:.5;font-weight:400}'
    /* Sharon, 28 Aug: the same breathing room Reya's configurator got. On Diane
       this block is Add Ons and it also sits directly under the swatch row.
       .bb-sect carries margin-top:24px !important from rn-vars, so this needs
       the extra class to out-specify it rather than relying on load order. */
    /* Sharon, 28 Aug, mobile then desktop: "add a line before that so there's
       breathing room. too tight to the top." A hairline rule separates Add Ons
       from the control above it at BOTH breakpoints -- unscoped, because the
       complaint was the same on each. The doubled class beats rn-mobile's
       .bb-sect{margin-top:20px !important} at 600px without a media query. */
    + '[id^="rn-bb-"] .bb-sect.rn-addons{margin-top:28px !important;padding-top:24px;'
    + 'border-top:1px solid var(--rn-line)}'
    /* Sharon, 28 Aug, on Ophelia: "we need a bit of breathing room before
       Performance Chatou Bouclé Pearl. Do it like the Diane and the Reya."

       The size picker is a bare .bb-opts, NOT wrapped in a .bb-sect, so the
       fabric section is its immediate next sibling. That adjacency exists only
       where show_size is on — Diane and Reya both have it off (Reya uses the
       configuration grid) — so this reaches Ophelia and nothing else, and two
       signed-off pages stay untouched. */
    + '[id^="rn-bb-"] .bb-opts[data-group="size"] + .bb-sect{margin-top:28px !important;'
    + 'padding-top:24px;border-top:1px solid var(--rn-line)}';
    document.head.appendChild(st);
  }

  function plain(cents) {
    if (!cents || cents <= 0) return '';
    /* Whole dollars stay whole -- every shelf price in this catalogue is one.
       Half of an odd dollar is not, and 47.50 shown as 48 is the row quoting a
       price the cart will not charge. */
    var opts = (cents % 100 === 0)
      ? {}
      : { minimumFractionDigits: 2, maximumFractionDigits: 2 };
    return 'C$' + (cents / 100).toLocaleString('en-CA', opts);
  }

  function money(cents) {
    var p = plain(cents);
    return p ? '+ ' + p : '';
  }

  /* WAS / NOW on the add-on row, matching the FBT block below it. The struck
     figure is the variant's own compare_at_price and is rendered ONLY where it
     is genuinely higher, so the row can never show a saving that is not real.
     Both halves are digits from plain(), so there is nothing to escape. */
  var BUNDLE_PCT = 50;   /* must match the automatic discount in Shopify */

  function priceHtml(v, bundled) {
    if (!v) return '';
    var now = money(v.price);
    if (!now) return '';
    var cmp = (v.compare_at_price && v.compare_at_price > v.price)
            ? plain(v.compare_at_price) : '';

    /* Struck figures read left to right, oldest first, so the eye lands on the
       payable number last. The unbundled row follows the same order for one
       strike, so two rows in one box never read in opposite directions. */
    if (!bundled) {
      return cmp ? '<s class="wasp">' + cmp + '</s>' + now : now;
    }
    var bcents = Math.round(v.price * (100 - BUNDLE_PCT) / 100);
    var out = '';
    if (cmp) out += '<s class="msrp">' + cmp + '</s>';
    out += '<s class="wasp">' + plain(v.price) + '</s>';
    out += '<b class="nowp">' + money(bcents) + '</b>';
    return out;
  }

  function currentSize() {
    var c = bb.querySelector('[data-bb-cfg]');
    if (c && c.getAttribute('data-cur-size')) return c.getAttribute('data-cur-size');
    var o = bb.querySelector('.bb-opts[data-group="size"] .bb-opt.on')
         || bb.querySelector('.bb-opts .bb-opt.on');
    var b = o && o.querySelector('b');
    return b ? b.textContent.trim() : null;
  }

  /* The colourway currently chosen for the sofa, used to preselect and to
     flag the matching pillow. */
  function currentColour() {
    var s = bb.querySelector('.bb-sw.on');
    return s ? (s.getAttribute('data-name') || '').trim() : null;
  }

  function variantFor(item, size) {
    if (!item.variants) return null;
    if (!size) return item.variants[0] || null;
    for (var i = 0; i < item.variants.length; i++) {
      if (item.variants[i].options.indexOf(size) >= 0) return item.variants[i];
    }
    return null;
  }

  /* A module row wants the ONE variant that is this module in this colour.
     Both must match: matching the module alone would put a Dune arm in a
     Moonstone cart, which is exactly the mistake this row shape exists to
     prevent. With no colour chosen yet there is nothing honest to show, so it
     returns null and the row disables itself rather than guessing a colour. */
  function variantForModule(item, colour) {
    if (!item.variants || !item.module || !colour) return null;
    var want = colour.toLowerCase();
    for (var i = 0; i < item.variants.length; i++) {
      var o = item.variants[i].options || [];
      var hasModule = false, hasColour = false;
      for (var j = 0; j < o.length; j++) {
        var val = String(o[j]).trim();
        if (val === item.module) hasModule = true;
        if (val.toLowerCase() === want) hasColour = true;
      }
      if (hasModule && hasColour) return item.variants[i];
    }
    return null;
  }

  /* Ask the Shopify CDN for a small file. The URL always carries ?v=, but the
     separator is worked out anyway rather than assumed. */
  function thumb(src) {
    return src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=80';
  }

  /* The row photo is a different job from the 34px swatch dot and needs its
     own request. It renders at 88 CSS px, so on a 2x screen 80px was being
     stretched to more than twice its size - that was the blur, not the
     source, which is 3200x2560. 240 covers 2x with room to spare.
     height + crop asks Shopify for a SQUARE centre crop: the originals are
     5:4, so squaring them puts more pillow and less backdrop in the frame. */
  function rowPhoto(src) {
    return src + (src.indexOf('?') >= 0 ? '&' : '?')
         + 'width=240&height=240&crop=center';
  }

  /* CUT-OUTS. Sharon supplied background-removed PNGs on 28 Aug, one per
     colourway, 2000x2000 RGBA. They beat the studio JPGs here because the
     row sits on a white card and the JPG backdrop measures #f7f7f7 - close
     to white, but close enough to read as a grey block against it.
     Keyed by colourway name, matched case-insensitively. A colour with no
     cut-out silently falls back to its studio photo. */
  var CUTOUT = {
    moonstone: 'RN_Sphere_Cutout_Moonstone.png',
    black:     'RN_Sphere_Cutout_Black.png',
    solstice:  'RN_Sphere_Cutout_Solstice.png',
    dune:      'RN_Sphere_Cutout_Dune.png',
    oat:       'RN_Sphere_Cutout_Oat.png',
    pearl:     'RN_Sphere_Cutout_Pearl.png'
  };
  var FILE_BASE = 'https://cdn.shopify.com/s/files/1/0716/0922/1235/files/';

  function cutout(colour, w) {
    if (!colour) return null;
    var f = CUTOUT[colour.toLowerCase().trim()];
    return f ? FILE_BASE + f + '?width=' + (w || 320) : null;
  }

  /* ---- build the block -------------------------------------------------- */
  var wrap = document.createElement('div');
  wrap.className = 'bb-sect rn-addons';
  wrap.setAttribute('data-rn-addons', '');
  var lab = document.createElement('p');
  lab.className = 'bb-lab';
  lab.textContent = cfg.heading;
  wrap.appendChild(lab);
  var list = document.createElement('div');
  list.className = 'rn-ao-list';
  wrap.appendChild(list);

  function makeRow(label, note, item) {
    var row = document.createElement('label');
    row.className = 'rn-ao';
    row.innerHTML =
      '<input type="checkbox">' +
      '<span class="bx">' + TICK + '</span>' +
      '<span class="th"></span>' +
      '<span class="tx"><b></b><em></em></span>' +
      '<span class="pr"></span>';
    row.querySelector('.tx b').textContent = label;
    row.querySelector('.tx em').textContent = note || '';
    /* THE FLAG IS PER ROW, NOT ON THE HEADING. Ophelia's block offers the
       mattress and the pillow at 50% and the drawers at full price under one
       "Bundle and save" heading. A heading cannot qualify itself, so the row
       that carries the discount is the thing that says so -- and the drawers
       row, carrying no flag, promises nothing it cannot keep. */
    if (item && item.bundled) {
      var fl = document.createElement('span');
      fl.className = 'rn-ao-flag';
      fl.textContent = BUNDLE_PCT + '% off';
      row.appendChild(fl);
    }
    /* An anchor is interactive content, so a click on it does NOT run the
       label's activation behaviour - the checkbox stays untouched and the
       link simply navigates. No stopPropagation needed. */
    if (item && item.link) {
      var lk = document.createElement('a');
      lk.className = 'lk';
      lk.href = item.link;
      lk.textContent = item.linkLabel || 'View details';
      row.querySelector('.tx').appendChild(lk);
    }
    return row;
  }

  /* Filled once the product JSON lands, which is the first moment a real
     photograph is known. Safe to call twice. desc is optional and is the
     only part of the card the row itself does not already show. */
  function setThumb(row, src, colour, label, note, desc, photo, rawSrc) {
    if (!row) return;
    var th = row.querySelector('.th');
    if (!th) return;
    /* rawSrc is a CDN image to use AS IS, width only and never centre-cropped.
       The module shots are tall product photographs, so the square crop that
       suits the pillow would take the arm off one. .th img is object-fit
       contain, so an uncropped tall image letterboxes inside the box rather
       than being cut. */
    if (rawSrc) {
      var sep = rawSrc.indexOf('?') >= 0 ? '&' : '?';
      var smallR = rawSrc + sep + 'width=320';
      var bigR = rawSrc + sep + 'width=700';
      return paint(row, th, smallR, bigR, label, note, desc);
    }
    var cut = photo ? (FILE_BASE + photo + '?width=320') : cutout(colour, 320);
    if (!cut && !src) return;
    var small = cut || rowPhoto(src);
    var big = photo ? (FILE_BASE + photo + '?width=700')
                    : (cutout(colour, 700) || (src ? rowPhoto(src) : null));

    return paint(row, th, small, big, colour ? (label + ' · ' + colour) : label, note, desc);
  }

  /* Draws the row photo and its hover card. Safe to call repeatedly — it
     reuses the elements it made the first time. */
  function paint(row, th, small, big, title, note, desc) {
    var im = th.firstChild;
    if (!im) {
      im = document.createElement('img');
      im.alt = '';
      im.loading = 'lazy';
      th.appendChild(im);
    }
    im.src = small;

    /* The enlarged card is a sibling of .th, not a child, so it is not
       clipped by the photo's own box and can sit above the row. */
    var zoom = row.querySelector('.rn-ao-zoom');
    if (!zoom) {
      zoom = document.createElement('span');
      zoom.className = 'rn-ao-zoom';
      zoom.innerHTML = '<img alt=""><b></b><span class="dm"></span><span class="ds"></span>';
      th.parentNode.insertBefore(zoom, th.nextSibling);
    }
    if (big) zoom.querySelector('img').src = big;
    zoom.querySelector('b').textContent = title;
    zoom.querySelector('.dm').textContent = note || '';
    zoom.querySelector('.ds').textContent = desc || '';
  }

  var rows = [];      /* size-matched add-ons */
  var groups = [];    /* swatched add-ons */

  cfg.items.forEach(function (item) {
    if (item.swatched) return;            /* built after its product loads */
    var row = makeRow(item.label, item.note, item);
    var rec = { item: item, row: row, input: row.querySelector('input'),
                priceEl: row.querySelector('.pr'), qty: 1,
                sizeMatched: !item.colourMatched,
                colourMatched: !!item.colourMatched };
    rec.input.addEventListener('change', function () {
      row.classList.toggle('on', rec.input.checked);
    });
    list.appendChild(row);
    rows.push(rec);
    item.rec = rec;
  });

  var form = bb.querySelector('form.bb-form, [data-bb-form]');
  if (form && form.parentNode) form.parentNode.insertBefore(wrap, form);
  else return;

  /* ---- ONE checkbox, swatches underneath -------------------------------- */
  function buildSwatched(item, product) {
    var grp = document.createElement('div');
    grp.className = 'rn-ao-grp';

    var row = makeRow(item.label, item.note, item);
    var input = row.querySelector('input');
    grp.appendChild(row);

    var sw = document.createElement('div');
    sw.className = 'rn-ao-sw';
    sw.setAttribute('role', 'group');
    sw.setAttribute('aria-label', 'Choose a colour for ' + item.label);
    grp.appendChild(sw);

    var hint = document.createElement('p');
    hint.className = 'rn-ao-hint';
    grp.appendChild(hint);

    var picksBox = document.createElement('div');
    picksBox.className = 'rn-ao-picks';
    grp.appendChild(picksBox);

    var g = { item: item, row: row, grp: grp, input: input, picks: [],
              hint: hint, priceEl: row.querySelector('.pr') };

    function setPick(rec, on) {
      rec.on = on;
      rec.btn.classList.toggle('on', on);
      rec.btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      rec.pick.style.display = on ? 'flex' : 'none';
      if (!on) { rec.qty = 1; rec.out.textContent = '1'; }
    }
    g.setPick = setPick;

    /* Called whenever a colour is dropped: with nothing left selected the
       add-on itself unticks, so it can never be on with nothing to add. */
    function untickIfEmpty() {
      var any = g.picks.some(function (p) { return p.on; });
      if (!any) {
        input.checked = false;
        grp.classList.remove('on');
        row.classList.remove('on');
      }
    }

    (product.variants || []).forEach(function (v) {
      if (!v.available) return;
      var colour = (v.options && v.options[v.options.length - 1]) || v.title;
      var src = v.featured_image && v.featured_image.src ? v.featured_image.src : null;
      /* 9 Oct 2026, Sharon: the "Bundle and save" swatch dots render as plain
         beige circles, no photo, for Sphere Pillow. Its variants carry no
         native featured_image at all, so src stayed null here even though
         this same file already has the real cut-out photos in CUTOUT/cutout()
         - just never applied to the swatch dot itself, only to the row's own
         hover-card thumbnail (setThumb, below). Same real photos, used here
         too. */
      var swImg = src ? thumb(src) : cutout(colour, 80);

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.title = colour;
      btn.setAttribute('aria-label', colour);
      btn.setAttribute('aria-pressed', 'false');
      if (swImg) {
        var im = document.createElement('img');
        im.src = swImg;
        im.alt = '';
        im.loading = 'lazy';
        btn.appendChild(im);
      }
      sw.appendChild(btn);

      var pick = document.createElement('div');
      pick.className = 'rn-ao-pick';
      pick.innerHTML = '<span class="nm"></span>'
                     + '<span class="qty"><button type="button" data-d="-1" aria-label="Remove one">&minus;</button>'
                     + '<output>1</output>'
                     + '<button type="button" data-d="1" aria-label="Add one">+</button></span>';
      pick.querySelector('.nm').textContent = colour;
      pick.style.display = 'none';
      picksBox.appendChild(pick);

      var rec = { variant: v, colour: colour, btn: btn, pick: pick,
                  out: pick.querySelector('output'), qty: 1, on: false };

      pick.querySelector('.qty').addEventListener('click', function (e) {
        var b = e.target.closest('button');
        if (!b) return;
        e.preventDefault();
        e.stopPropagation();
        var next = rec.qty + parseInt(b.getAttribute('data-d'), 10);
        if (next < 1) {
          /* Minus on the last one takes the colour back out, rather than
             sitting at 1 and looking broken. */
          setPick(rec, false);
          untickIfEmpty();
          return;
        }
        rec.qty = Math.min(20, next);
        rec.out.textContent = rec.qty;
      });

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        setPick(rec, !rec.on);
        /* Show whatever was just chosen. Deselecting falls back to the first
           colour still selected, else to the sofa's match. */
        if (rec.on) g.showColour(rec.colour);
        else {
          var still = g.picks.filter(function (p) { return p.on; })[0];
          g.showColour(still ? still.colour : g.defaultColour());
        }
        untickIfEmpty();
      });

      g.picks.push(rec);
    });

    if (!g.picks.length) return;    /* nothing buyable, nothing to show */

    /* The row photo IS the selected colourway, so the shopper sees the pillow
       they are actually adding rather than a generic shot. */
    g.showColour = function (c) {
      setThumb(row, product.featured_image, c, item.label, item.note, item.desc);
    };
    g.defaultColour = function () {
      var c = currentColour();
      if (c) {
        var m = g.picks.filter(function (p) {
          return p.colour.toLowerCase() === c.toLowerCase();
        })[0];
        if (m) return m.colour;
      }
      return g.picks[0].colour;
    };
    g.showColour(g.defaultColour());

    input.addEventListener('change', function () {
      var on = input.checked;
      grp.classList.toggle('on', on);
      row.classList.toggle('on', on);
      if (on) {
        /* Preselect the colour that matches the sofa, else the first one. */
        var any = g.picks.some(function (p) { return p.on; });
        if (!any) {
          var c = currentColour();
          var want = null;
          if (c) {
            want = g.picks.filter(function (p) {
              return p.colour.toLowerCase() === c.toLowerCase();
            })[0] || null;
          }
          setPick(want || g.picks[0], true);
        }
      } else {
        g.picks.forEach(function (p) { setPick(p, false); });
      }
    });

    g.priceEl.innerHTML = priceHtml(g.picks[0].variant, g.item && g.item.bundled);
    list.appendChild(grp);
    groups.push(g);
    flagMatch();
  }

  /* ---- keep it in step with the sofa ------------------------------------ */
  function flagMatch() {
    var c = currentColour();
    groups.forEach(function (g) {
      var hit = null;
      if (c) {
        hit = g.picks.filter(function (p) {
          return p.colour.toLowerCase() === c.toLowerCase();
        })[0] || null;
      }
      g.hint.textContent = hit ? hit.colour + ' matches your sofa' : '';
      if (g.showColour && !g.picks.some(function (p) { return p.on; })) {
        g.showColour(g.defaultColour());
      }
    });
  }

  function sync() {
    var size = currentSize();
    var colour = currentColour();
    rows.forEach(function (rec) {
      if (!rec.sizeMatched && !rec.colourMatched) return;
      var v = rec.colourMatched ? variantForModule(rec.item, colour)
                                : variantFor(rec.item, size);
      rec.variant = v;
      var ok = !!(v && v.available);
      rec.row.classList.toggle('off', !ok);
      rec.input.disabled = !ok;
      if (!ok && rec.input.checked) {
        rec.input.checked = false;
        rec.row.classList.remove('on');
      }
      rec.priceEl.innerHTML = ok ? priceHtml(v, rec.item && rec.item.bundled) : (v ? 'Unavailable' : '');
      /* sync() already runs on every size change, so the hover card follows the
         bed for free. setThumb is safe to call repeatedly — it reuses the
         elements it made the first time. */
      if (rec.item.dims) {
        var dl = (size && rec.item.dims[size]) || '';
        setThumb(rec.row, rec.item.img, null, rec.item.label, dl || rec.item.note, rec.item.desc, rec.item.photo);
      }
      /* The module row shows the module IN THE COLOUR BEING BOUGHT. Each of the
         36 variants has its own photograph, so this follows the sofa's swatch
         without a lookup table. Falls back to the product's own featured image
         if a variant somehow has none. */
      if (rec.colourMatched) {
        var vimg = v && v.featured_image && v.featured_image.src ? v.featured_image.src
                 : (rec.item.img || null);
        if (vimg) {
          setThumb(rec.row, null, null,
                   colour ? (rec.item.label + ' · ' + colour) : rec.item.label,
                   rec.item.note, rec.item.desc, null, vimg);
        }
      }
    });
    flagMatch();
  }

  /* Six module rows share one handle, so the product is fetched ONCE and the
     same result handed to each. Without this the Reya page made six identical
     requests for a 36-variant product to draw six rows. */
  var FETCHED = {};
  function fetchProduct(handle) {
    if (!FETCHED[handle]) {
      FETCHED[handle] = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return FETCHED[handle];
  }

  /* PRE-ORDER DATA PER ADD-ON PRODUCT: stock, allocation, container date and
     ref for every variant, from templates/product.rn-po-data.liquid (the .js
     endpoint carries neither stock nor metafields). Fetched once per handle,
     early, so it is ready by the time the sofa is added. null on any failure:
     the add-on then goes in as a plain line, as it always did. */
  var PO_DATA = {};
  function fetchPoData(handle) {
    if (!PO_DATA[handle]) {
      /* NO Accept: application/json here. On a product URL Shopify answers
         that header with its own built-in product JSON and ignores ?view=,
         so the template never ran and every add-on went in as a plain line. */
      PO_DATA[handle] = fetch('/products/' + handle + '?view=rn-po-data', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (t) {
          if (!t) return null;
          try { return JSON.parse(t).variants || null; } catch (err) { return null; }
        })
        .catch(function () { return null; });
    }
    return PO_DATA[handle];
  }

  function load(item) {
    fetchPoData(item.handle);
    fetchProduct(item.handle)
      .then(function (p) {
        if (!p || !p.variants) {
          /* An unpublished or missing add-on removes its own row rather than
             offering something that cannot be bought. */
          if (item.rec && item.rec.row && item.rec.row.parentNode) {
            item.rec.row.parentNode.removeChild(item.rec.row);
          }
          if (!list.children.length && wrap.parentNode) wrap.parentNode.removeChild(wrap);
          return;
        }
        item.variants = p.variants;
        item.img = p.featured_image;
        if (item.rec) setThumb(item.rec.row, p.featured_image, null, item.label, item.note, item.desc, item.photo);
        if (item.swatched) buildSwatched(item, p);
        sync();
      })
      .catch(function () { /* leave the row disabled rather than guessing */ });
  }
  cfg.items.forEach(load);
  sync();

  var cfgEl = bb.querySelector('[data-bb-cfg]');
  if (cfgEl && window.MutationObserver) {
    new MutationObserver(function () { setTimeout(sync, 40); })
      .observe(cfgEl, { attributes: true, attributeFilter: ['data-cur-size', 'data-cur-chaise'] });
  }
  bb.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.bb-cfgopt, .bb-opt, .bb-sw')) {
      setTimeout(sync, 80);
    }
  }, true);

  /* ---- add the ticked lines once the sofa itself is in ------------------ */
  document.addEventListener('cart:update', function (e) {
    if (!e.detail || e.detail.source !== 'rn-buybox') return;
    var picked = [];   /* {id, quantity, handle} */
    rows.forEach(function (rec) {
      if (rec.input && rec.input.checked && rec.variant && rec.variant.available) {
        picked.push({ id: rec.variant.id, quantity: rec.qty || 1, handle: rec.item.handle });
      }
    });
    groups.forEach(function (g) {
      if (!g.input.checked) return;
      g.picks.forEach(function (p) {
        if (p.on && p.qty > 0) picked.push({ id: p.variant.id, quantity: p.qty, handle: g.item.handle });
      });
    });
    if (!picked.length) return;

    /* PRE-ORDER ADD-ONS GO IN AS PRE-ORDER LINES. 26 September 2026. The same
       rule as the buy box: what is on the shelf (stock, less plain lines of
       that variant already in the cart; untracked counts as none) goes in as
       a plain line, and anything past it goes in as a second line carrying
       the arrival date and container -- RN_PO_PROPS in assets/rn-pdp-qty.js
       builds those, so the add-on's promise is worked out exactly like the
       sofa's. No container date, no data, or any failure: plain line, as
       before. Never blocks the add. */
    var handles = {};
    picked.forEach(function (x) { handles[x.handle] = true; });
    var dataP = Promise.all(Object.keys(handles).map(function (h) {
      return fetchPoData(h).then(function (d) { return { h: h, d: d }; });
    }));
    var cartP = fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });

    Promise.all([dataP, cartP]).then(function (res) {
      var byHandle = {};
      res[0].forEach(function (x) { byHandle[x.h] = x.d; });
      var shelfInCart = {};
      ((res[1] && res[1].items) || []).forEach(function (it) {
        if (it.properties && it.properties._preorder_eta) return;
        shelfInCart[it.variant_id] = (shelfInCart[it.variant_id] || 0) + it.quantity;
      });
      var items = [];
      picked.forEach(function (x) {
        var d = byHandle[x.handle];
        var v = d && d[String(x.id)];
        var props = v && v.eta && typeof window.RN_PO_PROPS === 'function' ? window.RN_PO_PROPS(v.eta, v.poRef, v.etaType) : null;
        if (!props) { items.push({ id: x.id, quantity: x.quantity }); return; }
        var stock = v.stock === null || v.stock === undefined ? 0 : Math.max(0, v.stock);
        var shelf = Math.max(0, stock - (shelfInCart[x.id] || 0));
        if (x.quantity <= shelf) { items.push({ id: x.id, quantity: x.quantity }); return; }
        if (shelf > 0) items.push({ id: x.id, quantity: shelf });
        items.push({ id: x.id, quantity: x.quantity - shelf, properties: props });
        shelfInCart[x.id] = (shelfInCart[x.id] || 0) + shelf;
      });
      return items;
    }, function () {
      return picked.map(function (x) { return { id: x.id, quantity: x.quantity }; });
    }).then(function (items) {
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      });
    }).then(function (res) {
      /* Tell everything that tracks the cart (the PDP quantity check, the
         cart caps) that the add-ons are in too. A different source, so the
         listener above -- which only acts on the buy box's own add -- ignores
         it and cannot loop. The drawer itself is re-rendered by rn-pdp-cart.js,
         which watches every /cart/add. */
      if (res && res.ok) {
        try { document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { source: 'rn-pdp-addon' } })); } catch (err) {}
      }
      rows.forEach(function (rec) {
        if (rec.input) { rec.input.checked = false; rec.row.classList.remove('on'); }
      });
      groups.forEach(function (g) {
        g.input.checked = false;
        g.row.classList.remove('on');
        g.grp.classList.remove('on');
        g.picks.forEach(function (p) { g.setPick(p, false); });
      });
    }).catch(function () { /* the sofa is already in the cart; never block it */ });
  });
})();
